import { createFileRoute } from "@tanstack/react-router";
import { apiLandingHead } from "~/features/api-landing/api-landing-metadata";

export const Route = createFileRoute("/api")({
  head: apiLandingHead,
});
